import { render, staticRenderFns } from "./PrintableBaseWidget.vue?vue&type=template&id=4c1cc7c7&scoped=true"
import script from "./PrintableBaseWidget.vue?vue&type=script&lang=js"
export * from "./PrintableBaseWidget.vue?vue&type=script&lang=js"
import style0 from "./PrintableBaseWidget.vue?vue&type=style&index=0&id=4c1cc7c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cc7c7",
  null
  
)

export default component.exports